import React from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from './Generic/ErrorBoundaries';
import Notifications from './Notifications';
import ClubBarBanner from './ClubBarBanner';
import OneHeader, { getBanners, NavBar } from 'OneHeader';
import RouteScrollToTop from 'Client/components/RouteScrollToTop';
import { RouterProvider } from 'Client/hooks/useRouter';
import { UserTrackingProvider } from 'Client/hooks/flags/useUserTracking';
import { isNativeAppPage as checkIsNativeAppPage } from 'Client/hooks/UrlManager/pageTypeService';
import useSegments from 'Client/hooks/useSegments';
import { ConfigurationsState } from 'Common/appshell_types/remoteConfigType';
import { useBellaSelector } from 'Client/redux/hooks';
import { CategoryData } from 'Client/redux/category/types';
import { AppShellLoginState } from 'Common/appshell_types';
import { LandingRedirectsData } from 'Client/redux/redirect/types';

const OneHeaderWithPropsFromStore = () => {
    const visibleOriginalCategories = useBellaSelector<CategoryData[]>(
        state => state.categories.visibleOriginalCategories
    );
    const appShellLogin = useBellaSelector<AppShellLoginState>(state => state.appShellLogin);
    const configurations = useBellaSelector<ConfigurationsState>(state => state.configurations);
    const landingRedirects = useBellaSelector<LandingRedirectsData | undefined>(
        state => state.redirect.landingRedirects
    );
    return (
        <OneHeader
            visibleOriginalCategories={visibleOriginalCategories}
            configurations={configurations}
            detachedHeaderMode={false}
            login={appShellLogin}
            landingRedirects={landingRedirects}
        />
    );
};

interface Props {
    host?: string;
}

const AppHeader = ({ host = '' }: Props) => {
    const segments = useSegments();

    return (
        <ErrorBoundary boundaryName="Header" fallbackComponent={null}>
            <Route>
                {routerProps => {
                    const isNativeAppPage = checkIsNativeAppPage(routerProps.location.pathname, segments);

                    return (
                        <RouterProvider
                            value={{
                                ...routerProps,
                                host,
                                disableClientsideNavigation: isNativeAppPage,
                                isAppWebviewPage: isNativeAppPage,
                            }}
                        >
                            <RouteScrollToTop />
                            <UserTrackingProvider>
                                {getBanners({ detachedHeaderMode: false }).map(({ Banner, key }) => (
                                    <Banner key={key} />
                                ))}
                                <OneHeaderWithPropsFromStore />
                                <NavBar detachedHeaderMode={false} />
                                <ClubBarBanner />
                                <Notifications />
                            </UserTrackingProvider>
                        </RouterProvider>
                    );
                }}
            </Route>
        </ErrorBoundary>
    );
};

export default AppHeader;
